import logger from '@/app/logger';

interface WindowSize {
    width: number;
    height: number;
}

interface WindowState {
    windowSize: WindowSize;
    displayedModals: string[];
}

// TODO: type this — Vuex dispatch/commit types
type AnyDispatch = (...args: any[]) => any;
type AnyCommit = (...args: any[]) => any;

const state: WindowState = {
    windowSize: { width: 100, height: 100 },
    displayedModals: [],
};

const getters = {
    isDisplayingModal(state: WindowState): boolean {
        return state.displayedModals.length > 0;
    },
};

const mutations = {
    updateWindowSize(state: WindowState, windowSize: WindowSize): void {
        state.windowSize = windowSize;
    },
    pushDisplayedModal(state: WindowState, modalId: string): void {
        state.displayedModals.push(modalId);
    },
    popDisplayedModal(state: WindowState, modalId: string): void {
        if (!state.displayedModals.includes(modalId)) {
            logger.warn(`popDisplayedModal() called with unknown modal ID ${modalId}`);
            return;
        }

        const modalIndex = state.displayedModals.indexOf(modalId);
        state.displayedModals.splice(modalIndex, 1);
    },
};

let trackWindowResize: (() => void) | undefined;

const actions = {
    windowResize({ commit }: { commit: AnyCommit }): void {
        commit('updateWindowSize', { width: window.innerWidth, height: window.innerHeight });
    },
    initiateFunctions({ dispatch }: { dispatch: AnyDispatch }): void {
        dispatch('windowResize');
        trackWindowResize = () => dispatch('windowResize');
    },
    addTracking({ dispatch }: { dispatch: AnyDispatch }): void {
        dispatch('initiateFunctions');
        if (trackWindowResize) window.addEventListener('resize', trackWindowResize);
    },
    removeTracking(): void {
        if (trackWindowResize) window.removeEventListener('resize', trackWindowResize);
    },
};

const WindowStore = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default WindowStore;
